<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="分类名称：">
            <el-input
              v-model="query.name"
              placeholder="请输入分类名称"
              clearable
              size="small"
            />
          </el-form-item>
          <!-- <el-form-item label="分类类别：">
            <el-select v-model="query.sourceType" placeholder="请选择" clearable size="small">
              <el-option label="分享物料" :value="1"></el-option>
              <el-option label="项目管理" :value="2"></el-option>
              <el-option label="顾客物料" :value="3"></el-option>
              <el-option label="案例展示" :value="4"></el-option>
              <el-option label="业务物料" :value="5"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="分类等级：">
            <el-select v-model="query.categoryLevel" placeholder="请选择" clearable size="small">
              <el-option label="一级" :value="1"></el-option>
              <el-option label="二级" :value="2"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="状态：">
            <el-select
              v-model="query.state"
              placeholder="请选择"
              clearable
              size="small"
            >
              <el-option label="启用" :value="1"></el-option>
              <el-option label="禁用" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleQuery" size="mini"
              >搜索</el-button
            >
            <el-button type="info" @click="handleFilter" plain size="mini"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <!-- 分类类别Tab过滤。共 9 个板块共用本页。
         「项目落地」(sourceType=10) 不在这里配，它有自己的
         【营销管理 - 项目落地 - 分区与分类】专属页；数据仍在同一张 template_classification 表。 -->
    <el-card class="box-card mt10">
      <el-tabs v-model="activeTab" @tab-click="handleTabClick">
        <el-tab-pane label="分享物料" name="1"></el-tab-pane>
        <el-tab-pane label="项目管理" name="2"></el-tab-pane>
        <el-tab-pane label="顾客物料" name="3"></el-tab-pane>
        <el-tab-pane label="案例展示" name="4"></el-tab-pane>
        <el-tab-pane label="业务物料" name="5"></el-tab-pane>
        <el-tab-pane label="品宣" name="6"></el-tab-pane>
        <el-tab-pane label="皮科普药" name="7"></el-tab-pane>
        <el-tab-pane label="新闻资讯" name="8"></el-tab-pane>
        <el-tab-pane label="患者就诊物料" name="9"></el-tab-pane>
      </el-tabs>
      
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <div class="btn-box">
          <el-dropdown @command="handleCommand">
            <el-button type="primary" size="mini"
              >批量操作<i class="el-icon--right el-icon-arrow-down"></i
            ></el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                :command="1"
                v-hasPermi="['goods:classify:state']"
                >批量启用</el-dropdown-item
              >
              <el-dropdown-item
                :command="2"
                v-hasPermi="['goods:classify:state']"
                >批量禁用</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
          <el-button
            type="primary"
            size="mini"
            @click="handleCreate"
            icon="el-icon-plus"
            v-hasPermi="['goods:classify:add']"
            >新增分类</el-button
          >
          <!-- <el-button type="danger" size="mini" @click="handleDeleteBatch" plain>批量删除</el-button> -->
        </div>
      </div>
      <el-table
        ref="dataTable"
        v-loading="listLoading"
        :data="list"
        row-key="id"
        :tree-props="{ children: 'childList', hasChildren: 'hasChildren' }"
        default-expand-all
        @selection-change="selectionChange"
        @sort-change="sortChange"
      >
        <el-table-column type="selection" width="50" />
        <!-- <el-table-column label="id" prop="id" align="center" /> -->
        <el-table-column
          label="分类名称"
          prop="name"
          align="center"
          width="200"
          fixed="left"
        />
        <el-table-column label="分类类别" prop="sourceType" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.sourceType === 1">分享物料</span>
            <span v-else-if="row.sourceType === 2">项目管理</span>
            <span v-else-if="row.sourceType === 3">顾客物料</span>
            <span v-else-if="row.sourceType === 4">案例展示</span>
            <span v-else-if="row.sourceType === 5">业务物料</span>
            <span v-else-if="row.sourceType === 6">品宣</span>
            <span v-else-if="row.sourceType === 7">皮科普药</span>
            <span v-else-if="row.sourceType === 8">新闻资讯</span>
            <span v-else-if="row.sourceType === 9">患者就诊物料</span>
            <span v-else-if="row.sourceType === 10">项目落地</span>
            <span v-else>{{ row.sourceType }}</span>
          </template>
        </el-table-column>
        <el-table-column label="背景图片" prop="bgImage" align="center">
          <template slot-scope="{ row }">
            <el-image
              style="width: 50px; height: 50px"
              :src="row.bgImage"
              :preview-src-list="[row.bgImage]"
              v-if="row.bgImage"
            ></el-image>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column
          label="描述"
          prop="description"
          align="center"
          width="200"
        />
        <el-table-column label="页面排序" prop="orderNo" align="center" />
        <el-table-column label="状态" prop="state" align="center" width="100">
          <template slot-scope="{ row }">
            <el-switch
              v-model="row.state"
              :active-value="1"
              :inactive-value="0"
              @change="changeSwitch(row)"
            ></el-switch
            >{{ row.state === 1 ? "启用" : "禁用" }}
          </template>
        </el-table-column>
        <el-table-column
          label="修改时间"
          prop="operatedTime"
          sortable="custom"
          align="center"
          width="200"
        />
        <el-table-column label="操作人" prop="operatedBy" align="center" />
        <el-table-column label="操作" align="center" width="230" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="text" @click="handleUpdate(row)">编辑</el-button>
            <!-- <el-button type="text" @click="handleDeleteSingle(row)">删除</el-button> -->
            <el-button
              type="text"
              @click="handleCreate(row)"
              v-if="(!row.parentId || row.parentId === 0)&&row.sourceType!==7"
              >新建二级分类</el-button
            >
            <el-button type="text" @click="handleJurisd(row)"
              >权限配置</el-button
            >
            <el-button type="text" @click="handleLog(row)">日志记录</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        v-show="total > 0"
        :total="total"
        :pageNo.sync="query.pageNo"
        :pageSize.sync="query.pageSize"
        @pagination="doQueryList"
      />
    </el-card>
    <!-- 新建表单 -->
    <classify-add
      ref="classifyAdd"
      @created="doQueryList({})"
      :menuOptions="list"
      :activeSourceType="Number(activeTab)"
    />
    <edit-juisd ref="editJuisd" @created="doQueryList({})" />
  </div>
</template>

<script>
import classifyAdd from "./add";
import templateClassificationApi from "@/api/marketing/templateClassification";
import Pagination from "@/components/Pagination";
import editJuisd from "./editJuisd.vue";
export default {
  components: {
    Pagination,
    classifyAdd,
    editJuisd
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      activeTab: "1",
      query: {
        pageNo: 1,
        pageSize: 10,
        sourceType: 1,
        orderNoSortSign: 1
      },
      selectItems: []
    };
  },
  created() {
    this.doQueryList({ pageNo: 1 });
  },
  methods: {
    handleLog(row) {
      this.$router.push("/log/log?type=121&id=" + row.id);
    },
    handleJurisd(row) {
      this.$refs.editJuisd.handleUpdate(row);
    },
    handleFilter() {
      this.query = {
        pageNo: 1,
        pageSize: 10,
        sourceType: Number(this.activeTab)
      };
      this.doQueryList({ pageNo: 1, pageSize: 10 });
    },
    /**
     * Tab切换处理
     */
    handleTabClick(tab) {
      this.activeTab = tab.name;
      this.query.sourceType = Number(tab.name);
      this.doQueryList({ pageNo: 1 });
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val;
    },
    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        createdTime: "createdTimeSortSign",
        operatedTime: "operatedTimeSortSign"
      };
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k];
        if (k !== prop) {
          this.query[sortKey] = null;
        } else {
          if (order === "ascending") {
            this.query[sortKey] = 1;
          } else {
            this.query[sortKey] = -1;
          }
        }
      }
      this.doQueryList({});
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 });
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo;
      }
      if (pageSize) {
        this.query.pageSize = pageSize;
      }
      this.listLoading = true;
      return templateClassificationApi
        .fetchTreeList(this.query)
        .then(data => {
          this.list = data.data.list || [];
          this.total = data.data.total;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    /**
     * 删除单条记录
     */
    handleDeleteSingle(row) {
      return this.$common
        .confirm("是否确认删除")
        .then(() => templateClassificationApi.deleteById(row.id))
        .then(() => {
          this.$common.showMsg("success", "删除成功");
          return this.doQueryList({ pageNo: 1 });
        });
    },
    /**
     * 批量删除记录
     */
    handleDeleteBatch() {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg("warning", "请选择分类");
        return;
      }
      return this.$common
        .confirm("是否确认删除")
        .then(() =>
          templateClassificationApi.deleteBatch(
            this.selectItems.map(row => row.id)
          )
        )
        .then(() => {
          this.$common.showMsg("success", "删除成功");
          return this.doQueryList({ pageNo: 1 });
        });
    },
    handleCommand(command) {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg("warning", "请选择分类");
        return;
      }
      let ids = this.selectItems.map(row => row.id);
      if (command === 1) {
        this.handleBatchState(ids, 1);
      } else if (command === 2) {
        this.handleBatchState(ids, 0);
      }
    },
    handleBatchState(ids, type) {
      let txt =
        type === 1 ? "确认将选中分类批量启用？" : "确认将选中分类批量禁用？";
      // 将 ids 数组转换为逗号分隔的字符串
      const idsStr = Array.isArray(ids) ? ids.join(",") : ids;
      this.$common
        .confirm(txt)
        .then(() => templateClassificationApi.updateStateBatch(idsStr, type))
        .then(() => {
          this.$common.showMsg("success", "操作成功");
          // 刷新列表时重置选择项
          this.selectItems = [];
          // 清除表格选择状态
          this.$nextTick(() => {
            if (this.$refs.dataTable) {
              this.$refs.dataTable.clearSelection();
            }
          });
          return this.doQueryList({});
        })
        .catch(err => {
          console.error("批量修改状态失败:", err);
        });
    },
    changeSwitch(row) {
      templateClassificationApi
        .updateStateBatch( row.id, row.state )
        .then(() => {
          this.$common.showMsg("success", "操作成功");
        });
    },
    /**
     * 打开新建表单
     */
    handleCreate(row) {
      this.$refs.classifyAdd.handleCreate(row);
    },
    /**
     * 打开查看表单
     */
    handleShow(row) {
      this.$refs.classifyShow.handleShow(row.id);
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(row) {
      this.$refs.classifyAdd.handleUpdate(row);
    }
  }
};
</script>
